import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axiosInstance from "./utils/axios";
import 'primeicons/primeicons.css';
import "./assets/main.css";
import KeyFilter from 'primevue/keyfilter';
import setupPrimeVue from "./plugins/primevue";

const app = createApp(App);

app.provide("$axios", axiosInstance);
app.use(router);
app.use(store);

// Primevue Configs
setupPrimeVue(app);
app.directive('keyfilter', KeyFilter);

app.mount("#app");
